import client from '../../client';
import uuid from 'uuid';
import uploadVideoToS3 from '../../common/utils/uploadVideoToS3';

export const ADD_LESSON = 'ADD_LESSON';
export const ADD_LESSON_VIDEO = 'ADD_LESSON_VIDEO';
export const DELETE_LESSON = 'DELETE_LESSON';
export const EDIT_LESSON = 'EDIT_LESSON';
export const FETCH_LESSONS = 'FETCH_LESSONS';
export const GET_LESSON_VIDEO = 'GET_LESSON_VIDEO';
export const REORDER_LESSONS = 'REORDER_LESSONS';
export const UPLOAD_LESSON_VIDEO = 'UPLOAD_LESSON_VIDEO';
export const UPLOAD_LESSON_VIDEO_PROGRESS = 'UPLOAD_LESSON_VIDEO_PROGRESS';

export function addLesson(courseId, chapterId, values) {
  return {
    type: ADD_LESSON,
    promise: client.post(`courses/${courseId}/chapters/${chapterId}/lessons`, values),
  };
}

export function addLessonVideo(courseId, chapterId, id, key) {
  return {
    type: ADD_LESSON_VIDEO,
    promise: client.post(`courses/${courseId}/chapters/${chapterId}/lessons/${id}/videos`, { key }),
  };
}

export function deleteLesson(courseId, chapterId, lessonId) {
  return {
    lessonId,
    type: DELETE_LESSON,
    promise: client.delete(`courses/${courseId}/chapters/${chapterId}/lessons/${lessonId}`),
  };
}

export function editLesson(courseId, chapterId, id, values) {
  const data = new FormData();
  if (values.image_id) data.append('image_id', values.image_id);
  if (values.image) data.append('image', values.image, uuid.v4());
  data.append('name', values.name);
  data.append('video_sections', JSON.stringify(values.video_sections));

  return {
    type: EDIT_LESSON,
    promise: client.put(`courses/${courseId}/chapters/${chapterId}/lessons/${id}`, data),
  };
}

export function fetchLessons(courseId, chapterId) {
  return {
    type: FETCH_LESSONS,
    promise: client.get(`courses/${courseId}/chapters/${chapterId}/lessons/all`),
  };
}

export function getLessonVideo(courseId, chapterId, lessonId) {
  return {
    lessonId,
    type: GET_LESSON_VIDEO,
    promise: client.get(`courses/${courseId}/chapters/${chapterId}/lessons/${lessonId}/video`, null, {
      credentials: 'include', // Required for browser to respect Set-Cookie headers
    }),
  };
}

export function reorderLessons(values) {
  return {
    type: REORDER_LESSONS,
    promise: client.patch('lessons/sort-order', values),
  };
}

export function updateUploading(uploading) {
  return {
    type: UPLOAD_LESSON_VIDEO,
    uploading,
  };
}

export function updateUploadProgress(loaded, total) {
  return {
    type: UPLOAD_LESSON_VIDEO_PROGRESS,
    loaded,
    total,
  };
}

export function uploadVideo(courseId, chapterId, lessonId, file) {
  return dispatch => {
    dispatch(updateUploading(true));

    return uploadVideoToS3(dispatch, file, updateUploadProgress)
      .then(data => dispatch(addLessonVideo(courseId, chapterId, lessonId, data.Key)))
      .then(() => dispatch(getLessonVideo(courseId, chapterId, lessonId)))
      .then(() => {
        dispatch(updateUploading(false));
        dispatch(updateUploadProgress(0, 100));
      });
  };
}



// WEBPACK FOOTER //
// ./src/courses/lessons/actions.js